// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-calendar__month-view__weekdays__weekday {
  font-size: 12px !important;
  text-transform: capitalize !important;
}
.react-calendar__navigation__next2-button, .react-calendar__navigation__prev2-button {
  display: none !important;
}
.react-calendar__tile--now {
  background-color: #F17A20 !important;
}
.react-calendar__navigation__label__labelText {
  font-size: 14px !important;
}
.react-calendar__month-view__days__day {
  padding: 6px 4px !important;
  font-size: 12px !important;
}
.react-calendar__month-view__weekdays__weekday abbr {
  text-decoration: none !important;
} 
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.scrollbar-hide {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;     /* Firefox */
}
.gradient-overlay {
  position: absolute !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 2rem !important;
  background-image: linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.6), transparent) !important;
  pointer-events: none !important;
}
.custom-scrollbar-hidden {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.custom-scrollbar-hidden::-webkit-scrollbar {
  display: none;
}

/* Admin sidebar Menu — scoped (moved from src/index.css so Teacher/other menus are unaffected) */
/* The sider <nav> already has its own \`border-r\` (Tailwind); antd's Menu also
   draws its own border-inline-end by default, which doubled the sidebar's
   right border. Disable the Menu's own border so only one line remains. */
/* Content Area type 1 — /admin/reporting_practice */
.content-area-type-1 {
  background-color: #F6F7F9;
}

[dir="ltr"] .layout-admin-sider-menu .ant-menu {
  border-right: none !important;
}

[dir="rtl"] .layout-admin-sider-menu .ant-menu {
  border-left: none !important;
}

.layout-admin-sider-menu .ant-menu-item {
  color: #f17a20 !important;
}

.layout-admin-sider-menu .ant-menu-item .ant-menu-title-content {
  color: #000 !important;
}

.layout-admin-sider-menu .ant-menu-item .ant-menu-title-content {
  font-weight: 700;
}

.layout-admin-sider-menu .ant-menu-item-selected {
  background-color: #f17a20 !important;
  color: #fff !important;
}

.layout-admin-sider-menu .ant-menu-item-selected .ant-menu-title-content {
  color: #fff !important;
}

.layout-admin-sider-menu .ant-menu-submenu-title {
  color: #f17a20 !important;
}

.layout-admin-sider-menu .ant-menu-submenu-title .ant-menu-title-content,
.layout-admin-sider-menu .ant-menu-submenu-arrow {
  color: #000 !important;
}

.layout-admin-sider-menu .ant-menu-submenu-title .ant-menu-title-content,
.layout-admin-sider-menu .ant-menu-submenu-arrow {
  font-weight: 700;
}

.layout-admin-sider-menu .ant-menu-item-only-child .ant-menu-title-content {
  font-weight: 500 !important;
}

.layout-admin-sider-menu .ant-menu-inline-collapsed .ant-menu-item svg {
  margin-left: -5px !important;
  margin-top: 8px !important;
}

.layout-admin-sider-menu .ant-menu-inline-collapsed .ant-menu-submenu .ant-menu-submenu-title svg {
  margin-left: -5px !important;
  margin-top: 8px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/LayoutAdmin/index.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,MAAM,YAAY;AACzC;AACA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,6IAA6I;EAC7I,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;;AAEA,iGAAiG;AACjG;;0EAE0E;AAC1E,oDAAoD;AACpD;EACE,yBAAyB;AAC3B;;AAEA;EACE;AACF;;AAFA;EACE;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AAExB;;AAHA;EAEE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;AAExB;;AAJA;;EAGE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B","sourcesContent":[".react-calendar__month-view__weekdays__weekday {\n  font-size: 12px !important;\n  text-transform: capitalize !important;\n}\n.react-calendar__navigation__next2-button, .react-calendar__navigation__prev2-button {\n  display: none !important;\n}\n.react-calendar__tile--now {\n  background-color: #F17A20 !important;\n}\n.react-calendar__navigation__label__labelText {\n  font-size: 14px !important;\n}\n.react-calendar__month-view__days__day {\n  padding: 6px 4px !important;\n  font-size: 12px !important;\n}\n.react-calendar__month-view__weekdays__weekday abbr {\n  text-decoration: none !important;\n} \n.scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n\n.scrollbar-hide {\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;     /* Firefox */\n}\n.gradient-overlay {\n  position: absolute !important;\n  bottom: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  height: 2rem !important;\n  background-image: linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.6), transparent) !important;\n  pointer-events: none !important;\n}\n.custom-scrollbar-hidden {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n.custom-scrollbar-hidden::-webkit-scrollbar {\n  display: none;\n}\n\n/* Admin sidebar Menu — scoped (moved from src/index.css so Teacher/other menus are unaffected) */\n/* The sider <nav> already has its own `border-r` (Tailwind); antd's Menu also\n   draws its own border-inline-end by default, which doubled the sidebar's\n   right border. Disable the Menu's own border so only one line remains. */\n/* Content Area type 1 — /admin/reporting_practice */\n.content-area-type-1 {\n  background-color: #F6F7F9;\n}\n\n.layout-admin-sider-menu .ant-menu {\n  border-inline-end: none !important;\n}\n\n.layout-admin-sider-menu .ant-menu-item {\n  color: #f17a20 !important;\n}\n\n.layout-admin-sider-menu .ant-menu-item .ant-menu-title-content {\n  color: #000 !important;\n  font-weight: 700;\n}\n\n.layout-admin-sider-menu .ant-menu-item-selected {\n  background-color: #f17a20 !important;\n  color: #fff !important;\n}\n\n.layout-admin-sider-menu .ant-menu-item-selected .ant-menu-title-content {\n  color: #fff !important;\n}\n\n.layout-admin-sider-menu .ant-menu-submenu-title {\n  color: #f17a20 !important;\n}\n\n.layout-admin-sider-menu .ant-menu-submenu-title .ant-menu-title-content,\n.layout-admin-sider-menu .ant-menu-submenu-arrow {\n  color: #000 !important;\n  font-weight: 700;\n}\n\n.layout-admin-sider-menu .ant-menu-item-only-child .ant-menu-title-content {\n  font-weight: 500 !important;\n}\n\n.layout-admin-sider-menu .ant-menu-inline-collapsed .ant-menu-item svg {\n  margin-left: -5px !important;\n  margin-top: 8px !important;\n}\n\n.layout-admin-sider-menu .ant-menu-inline-collapsed .ant-menu-submenu .ant-menu-submenu-title svg {\n  margin-left: -5px !important;\n  margin-top: 8px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
